import { MagnitudePage } from "./MagnitudePage";
import { isMagnitudeTemplate } from "./utils/isMagnitudeTemplate";

export { MagnitudePage, isMagnitudeTemplate };
